<template>
  <div>
    <el-dialog title="管理分类" :visible.sync="visible" width="650px" :before-close="handleClose">
      <el-form :model="classifyForm" label-width="100px" style="padding: 0 40px 0 0">
        <el-form-item label="人群来源:" required>
          <el-select v-model="classifyForm.type" @change="typeChange" style="width:320px" :disabled="!!this.classifyForm.id">
            <el-option label="自定义人群(官方)" :value="1"></el-option>
            <!-- <el-option label="自定义人群(云起)" :value="13"></el-option> -->
            <el-option label="运算人群" :value="12"></el-option>
          </el-select>
          <span class="btn" @click="create(0,{id: classifyForm.type})">创建分类</span>
        </el-form-item>
        <el-form-item label="人群分类:" required>
          <div style="min-height: 200px;max-height: 500px;overflow:auto;" v-loading="dataLoading">
            <el-tree 
              ref="tree" 
              :data="treeData" 
              node-key="id" 
              :expand-on-click-node="false"
              :draggable="true"
              default-expand-all
              @node-drop="nodeDrop"
              :allow-drop="allowDrop"
            >
              <div class="tree_line" slot-scope="{ node, data }">
                <span>
                  <el-input :id="'input' + data.id" v-model="data.name" style="width: 200px"
                    :disabled="data.disabled"></el-input>
                </span>
                <span class="btns" v-if="data.id !== -1 && data.id !== 0">
                  <span class="btn" v-if="node.level != 3 && data.disabled" @click="create(node, data)">创建子分类</span>
                  <span class="btn" v-if="data.disabled" @click="edit(node, data)">修改</span>
                  <span class="btn" v-else @click="editSure(node, data)">保存</span>
                  <span class="btn" v-if="data.disabled" @click="del(node, data)">删除</span>
                </span>
              </div>
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -20px;text-align: right">
        <el-button @click="handleClose" style="border: 1px solid #ddd">取 消</el-button>
        <el-button type="primary" @click="saveClassify">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 删除分类 -->
    <el-dialog title="提示" :visible.sync="delClassVisible" width="400px">
      <div>
        <img src="@/assets/images/tips_icon.png" style="width: 20px;position:relative;top: -14px;left:20px;">
        <div style="display:inline-block;margin-left:32px;font-size: 14px;width: 300px;line-height: 20px;">
          删除后，该分类下的人群会移入未分类<div>是否确定删除？</div></div>
      </div>
      <span slot="footer">
        <jd-button type="default" style="margin-right: 10px;" @click="delClassVisible = false">取 消</jd-button>
        <jd-button type="break" @click="handleDelSure">确 定</jd-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateCrowdClassify, delCrowdClassify, getTreeData, changeClassify } from "@/api/manage/memberCrowdController";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object | Array,
      default: () => { }
    },
  },
  data() {
    return {
      classifyForm: {
        id: null,
        type: 1,
        name: "",
      },
      treeDataTotal: [], // 总的分类数据
      treeData: [],
      lastId: 7,
      delClassVisible: false,
      delData: {},
      dataLoading: false,
    }
  },
  mounted() {
    let arr = []
    this.treeData.forEach(item => {
      arr.push(item.id - 0)
      item.children.forEach(item2 => {
        arr.push(item2.id - 0)
        item2.children.forEach(item3 => {
          arr.push(item3.id - 0)
        })
      })
    })
    this.lastId = Math.max(...arr)
    this.getTreeData()
  },
  methods: {
    // 拖拽监听
    nodeDrop(thisNode, endNode, position, event){
      console.log("当前节点", thisNode);
      console.log("最后进入的节点", endNode);
      console.log("被拖拽节点的放置位置(before、after、inner)", position);
      // 直接拖动到某一级分类 进入下一级分类
      if(position == "inner"){
        let ids = []
        endNode.data.children.forEach(item => {
          ids.push(item.id)
        })
        this.dropSubmit(thisNode.data.id,endNode.data.id,ids.join(","))
      } else {
        // 直接拖到目标节点前后
        if(endNode.level == 1){
          let ids = []
          this.treeData.forEach(item => {
            ids.push(item.id)
          })
          this.dropSubmit(thisNode.data.id, this.classifyForm.type, ids.join(","))
        } else {
          let ids = []
          let level = endNode.level
          this.treeData.forEach(item => {
            if(level == 2){
              if(item.id == endNode.data.parentId){
                item.children.forEach(item2 => {
                  ids.push(item2.id)
                })
              }
            }else{
              if(item.children){
                item.children.forEach(item2 => {
                  if(item2.id == endNode.data.parentId){
                    item2.children.forEach(item3 => {
                      ids.push(item3.id)
                    })
                  }
                })
              }
            }
          })
          this.dropSubmit(thisNode.data.id, endNode.data.parentId, ids.join(","))
        }
      }
    },
    // 拖拽提交
    dropSubmit(id, parentId, sortCondition){
      let param = {
        type: this.classifyForm.type,
        id,
        parentId,
        sortCondition,
      }
      changeClassify(param).then(res => {
        if(res.code == 1){
          this.$message.success(res.message)
        }else{
          this.$message.error(res.message)
        }
        // this.getTreeData()
      })
    },
    // 限制不可拖拽进入三级节点
    allowDrop(draggingNode, dropNode, type){
      console.log(draggingNode, dropNode, type);
      if(type == "inner" && dropNode.level == 3){
        return false
      }
      if(draggingNode.data.id == 0 || draggingNode.data.id == -1 || draggingNode.data.id === ""){
        return false
      }
      return true
    },
    // 查询人群分类
    getTreeData(){
      this.dataLoading = true
      getTreeData().then(res => {
        if(res.code == 1){
          let tree = res.data[0].children
          this.treeDataTotal = []
          tree.forEach(item1 => {
            if(item1.id == 1 || item1.id == 12 || item1.id == 13){
              if(item1.children){
                item1.children.forEach(item2 => {
                  item2.disabled = true
                  if(item2.children){
                    item2.children.forEach(item3 => {
                      item3.disabled = true
                      if(item3.children){
                        item3.children.forEach(item4 => {
                          item4.disabled = true
                        })
                      }
                    })
                  }
                })
              }
              this.treeDataTotal.push(item1)
            }
          })
          console.log('总树状data',this.treeDataTotal);
          this.typeChange()
        }
        this.dataLoading = false
      })
    },
    typeChange(){
      let type = this.classifyForm.type
      console.log(this.treeDataTotal);
      this.treeDataTotal.forEach(item => {
        if(item.id == type){
          if(item.children){
            this.treeData = JSON.parse(JSON.stringify(item.children))
          }else{
            this.treeData = []
          }
        }
      })
      console.log('当前来源树状data',this.treeData);
    },
    // 创建分类
    create(node, data) {
      // let param = {
      //   type: this.classifyForm.type,
      //   name: "未分类",
      //   parentId: data.id
      // }
      console.log(this.treeData);
      // updateCrowdClassify(param).then(res => {
      //   if(res.code == 1){
      //     this.getTreeData()
      //   }
      // })
      let obj = {
        disabled: false,
        id: "",
        name: "",
        parentId: data.id,
        type: this.classifyForm.type
      }
      if(node === 0){
        this.treeData.push(obj)
      }else{
        let level = node.level
        this.treeData.forEach(item1 => {
          if(level == 1){
            if(item1.id == data.id){
              if(item1.children){
                item1.children.push(obj)
              }else{
                this.$set(item1,'children',[obj])
              }
            }
          }else if(level == 2){
            if(item1.children){
              item1.children.forEach(item2 => {
                if(item2.id == data.id){
                  if(item2.children){
                    item2.children.push(obj)
                  }else{
                    this.$set(item2,'children',[obj])
                  }
                }
              })
            }
          }
        })
      }
    },
    // 修改分类
    edit(node, data) {
      console.log(node, data);
      let _this = this
      data.disabled = false
      this.$nextTick(() => {
        let el = document.getElementById('input' + data.id)
        el.focus()
      })
    },
    // 保存修改
    editSure(node, data) {
      let param = {
        type: this.classifyForm.type,
        name: data.name,
        id: data.id,
      }
      let isNew = false
      if(data.id === ""){ // 新增
        param = {
          type: this.classifyForm.type,
          name: data.name,
          parentId: data.parentId
        }
        isNew = true
      }
      updateCrowdClassify(param).then(res => {
        if(res.code == 1){
          data.disabled = true
          this.$message.success(res.message)
          if(isNew){
            this.getTreeData()
          }
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 删除分类
    del(node, data) {
      console.log(node, data);
      this.delData = data
      this.delClassVisible = true
    },
    async handleDelSure(){
      let res = await delCrowdClassify(this.delData.id)
      if(res.code == 1){
        this.$message.success(res.message)
        this.getTreeData()
      }else{
        this.$message.error(res.message)
      }
      this.delClassVisible = false
    },
    // 保存
    saveClassify() {
      this.$emit("close")
    },
    // 关闭
    handleClose() {
      this.$emit("close")
    },
    setDisable() {
      this.treeData.forEach(item => {
        item.disabled = true
        item.children.forEach(item2 => {
          item2.disabled = true
          item2.children.forEach(item3 => {
            item3.disabled = true
          })
        })
      })
    },
    // 树状结构格式化
    treeDataTren(list) {
      let child = function (parentId) {
        let arr = []
        console.log(parentId);
        list.forEach(item => {
          if (item.parentId == parentId) {
            let obj = {...item}
            obj.children = child(item.id)
            if (!obj.children.length) delete obj.children
            arr.push(obj)
          }
        })
        return arr
      }
      return child(0)
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tree-node__content {
  height: 45px;

  &:hover .btns {
    display: inline;
  }
}

/deep/.el-tree-node:focus>.el-tree-node__content {
  background-color: transparent !important;
}

/deep/.el-tree-node:hover>.el-tree-node__content {
  background-color: transparent !important;
}

.tree_line {
  .btns {
    display: none;
    margin-left: 10px;
    color: #2768FF;

    .btn {
      cursor: pointer;
      margin-left: 20px;
    }
  }
}

.btn {
  cursor: pointer;
  margin-left: 20px;
  color: #2768FF;
}
</style>